Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingList75182816",
  {"root":"OfferingList75182816--root"},
  "",
  10,
  "OfferingList75182816"
);

